export const SAVE_MOBILIZE_DATA = 'mobilize/SAVE_MOBILIZE_DATA'
